

// Function to calculate the number of days until the next payment
const calculateDaysUntilNextPayment = (paymentDateString) => {
    // Parse the payment date string into a Date object.
    const paymentDate = new Date(paymentDateString);

    // Get the current date.
    const currentDate = new Date();

    // Calculate the difference in time (milliseconds).
    const timeDifference = paymentDate - currentDate;

    // Convert from milliseconds to days.
    const daysUntilNextPayment = Math.ceil(timeDifference / (1000 * 60 * 60 * 24)); // Using Math.ceil to round up

    return daysUntilNextPayment < 0 ? 0 : daysUntilNextPayment; // Prevent negative days
};

export {calculateDaysUntilNextPayment};